export default __webpack_public_path__ + "static/media/zamtel.068c4836.png";